import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Landing.css";
import { Link } from "react-router-dom";

function Nav() {
  const navigate = useNavigate();
  const [solid, setSolid] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setSolid(window.scrollY > 20);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const links = [
    ["/"        , "Home"    ],
    ["/about"   , "About"   ],
    ["/projects", "Projects"],
    ["/contact1" , "Contact" ],
  ];

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      <nav className={`nav${solid ? " solid" : ""}`}>
        <div className="nav-inner">
          <div className="nav-logo" onClick={() => go("/")} style={{color: "#3FC1C9"}}>
            SERITONEX<div className="nav-logo-dot" />
          </div>

          {/* Desktop links */}
          <div className="nav-links">
            {links.map(([path, label]) => (
              <button
                key={path}
                className={`nav-link${window.location.pathname === path ? " active" : ""}`}
                onClick={() => go(path)}
              >
                {label}
              </button>
            ))}
           <button className="nav-cta" onClick={() => go("/shop")}>
              Shop
            </button>
          </div>

          {/* Hamburger — mobile only */}
          <button
            className={`nav-hamburger${menuOpen ? " nav-hamburger--open" : ""}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="mob-nav-overlay" onClick={() => setMenuOpen(false)}>
          <div className="mob-nav-drawer" onClick={e => e.stopPropagation()}>
            <div className="mob-nav-header">
              <div className="nav-logo" style={{ cursor: "pointer" }} onClick={() => go("/")}>
                SERITONEX<div className="nav-logo-dot" />
              </div>
              <button className="mob-nav-close" onClick={() => setMenuOpen(false)}>✕</button>
            </div>
            <div className="mob-nav-links">
              {links.map(([path, label]) => (
                <button
                  key={path}
                  className={`mob-nav-link${window.location.pathname === path ? " mob-nav-link--active" : ""}`}
                  onClick={() => go(path)}
                >
                  {label}
                </button>
              ))}
           <button className="nav-cta" onClick={() => go("/shop")}>
              Shop
            </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function About() {
  return (
    <div className="landing-root">
      <Nav />
      <div className="page">

        {/* ── HERO ───── */}
        <section className="about-hero">
          <div className="about-hero-inner container">
            <div className="overline">About Seritonex</div>
            <h1 className="about-title">
              Built For <span>Results</span>.<br />
              Driven By <em>Innovation</em>.
            </h1>
            <p className="about-sub">
              Driving innovation, scalability, and reliability in every line of code.
              We empower businesses to thrive in the digital era.
            </p>
          </div>
        </section>

        <div className="h-rule" />

        {/* ── MISSION + VISION ─────────────────────── */}
        <section className="mv-section">
          <div className="mv-card">
            <div className="mv-tag">// 01 — Mission</div>
            <h2 className="mv-title">Our Mission</h2>
            <p className="mv-body">
              To provide cutting-edge software solutions that enhance business performance
              and drive growth. We aim to be a trusted partner for our clients, delivering
              quality and value in every project.
            </p>
          </div>
          <div className="mv-card">
            <div className="mv-tag">// 02 — Vision</div>
            <h2 className="mv-title">Our Vision</h2>
            <p className="mv-body">
              To be a leader in the software development industry, recognized for
              innovation, quality, and customer satisfaction. We envision technology
              seamlessly integrated into everyday business, making operations smarter
              and faster.
            </p>
          </div>
        </section>

        {/* ── VALUES ───────────────────────────────── */}
        <section className="values-section">
          <div className="values-header">
            <div className="overline">Core Values</div>
            <h2 className="values-title">What We<br /><em>Stand For</em></h2>
          </div>
          <div className="values-grid">
            <div className="val-card">
              <div className="val-img-wrap">
                <img src="/Logo.png" alt="Innovation" className="val-img" />
              </div>
              <div className="val-body">
                <div className="val-name">Innovation</div>
                <p className="val-desc">We push boundaries to create transformative solutions that set new industry standards.</p>
              </div>
            </div>
            <div className="val-card">
              <div className="val-img-wrap">
                <img src="/Logo.png" alt="Excellence" className="val-img" />
              </div>
              <div className="val-body">
                <div className="val-name">Excellence</div>
                <p className="val-desc">Every project is executed with attention to detail, precision, and performance.</p>
              </div>
            </div>
            <div className="val-card">
              <div className="val-img-wrap">
                <img src="/Logo.png" alt="Trust" className="val-img" />
              </div>
              <div className="val-body">
                <div className="val-name">Trust</div>
                <p className="val-desc">We build long-lasting relationships with clients based on transparency and results.</p>
              </div>
            </div>
            <div className="val-card">
              <div className="val-img-wrap">
                <img src="/Logo.png" alt="Teamwork" className="val-img" />
              </div>
              <div className="val-body">
                <div className="val-name">Teamwork</div>
                <p className="val-desc">Collaboration is at our core — with clients and within our own team of experts.</p>
              </div>
            </div>
          </div>
        </section>

        {/* ── WHAT WE DO ───────────────────────────── */}
        <section className="exp-section">
          <div className="exp-inner">
            <div className="exp-header">
              <div>
                <div className="overline">Expertise</div>
                <h2 className="exp-title">What We Do</h2>
              </div>
            </div>
            <div className="exp-grid">
              <div className="exp-card" data-n="01">
                <div className="exp-num">// 01</div>
                <div className="exp-name">Web Development</div>
                <p className="exp-desc">We craft fast, scalable, and modern web applications tailored for your business goals.</p>
              </div>
              <div className="exp-card" data-n="02">
                <div className="exp-num">// 02</div>
                <div className="exp-name">Mobile Applications</div>
                <p className="exp-desc">Seamless mobile experiences across iOS and Android that your customers will love.</p>
              </div>
              <div className="exp-card" data-n="03">
                <div className="exp-num">// 03</div>
                <div className="exp-name">Cloud Integration</div>
                <p className="exp-desc">Cloud-powered solutions that scale with your company and optimize performance.</p>
              </div>
              <div className="exp-card" data-n="04">
                <div className="exp-num">// 04</div>
                <div className="exp-name">UI/UX Design</div>
                <p className="exp-desc">Intuitive and stunning designs that keep users engaged and coming back.</p>
              </div>
            </div>
          </div>
        </section>

        {/* ── TEAM ─────────────────────────────────── */}
        <section className="team-section">
          <div className="team-inner">
            <div className="team-header">
              <div className="overline">The Team</div>
              <h2 className="team-title">Meet Our Experts</h2>
            </div>
            <div className="team-grid">
              <div className="team-card">
                <div className="team-img-wrap">
                  <img src="/Logo.png" alt="Member 1" className="team-img" />
                </div>
                <div className="team-name">Name 1</div>
                <div className="team-role">Role 1</div>
                <div className="team-stack">Tech Stack:</div>
              </div>
              <div className="team-card">
                <div className="team-img-wrap">
                  <img src="/Logo.png" alt="Member 2" className="team-img" />
                </div>
                <div className="team-name">Name 2</div>
                <div className="team-role">Role 2</div>
                <div className="team-stack">Tech Stack:</div>
              </div>
              <div className="team-card">
                <div className="team-img-wrap">
                  <img src="/Logo.png"alt="Member 3" className="team-img" />
                </div>
                <div className="team-name">Name 3</div>
                <div className="team-role">Role 3</div>
                <div className="team-stack">Tech Stack:</div>
              </div>
            </div>
          </div>
        </section>

        {/* ── CALL TO ACTION ───────────────────────── */}
        <div className="cta-banner">
          <h2 className="cta-banner-title">
            Want to start a project<br />
            <span>with us?</span>
          </h2>
          <Link to="/contact1">
            <button className="cta-banner-btn">
              Contact Us
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </Link>
        </div>

      </div>
    </div>
  );
}
export default About;